import { LlmModelsAdminPage } from '@/components/settings/LlmModelsAdmin.web';

export default LlmModelsAdminPage;
